import { render } from "./LoadingError.vue?vue&type=template&id=b67b5f92&ts=true"
import script from "./LoadingError.vue?vue&type=script&lang=ts"
export * from "./LoadingError.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__